import { jsxs as r, jsx as C } from "react/jsx-runtime";
import { c as e, h as l } from "../../_chunks/VideoPlayerIcons.css.CABSRJZT.js";
const s = ({ size: c = 62 }) => /* @__PURE__ */ r(
  "svg",
  {
    width: c,
    height: c,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ C("circle", { cx: "32", cy: "32", r: "31", className: e }),
      /* @__PURE__ */ C("g", { clipPath: "url(#clip0_17083_15716)", children: /* @__PURE__ */ C(
        "path",
        {
          className: l,
          d: "M35.9386 46.55C35.5468 46.6624 35.1667 46.3604 35.1667 45.9527V44.4268C35.1667 44.1464 35.3516 43.901 35.6172 43.8113C37.9103 43.0365 39.792 41.6592 41.2625 39.6791C42.8282 37.5712 43.611 35.1782 43.611 32.5C43.611 29.8218 42.8325 27.4241 41.2756 25.307C39.8137 23.3192 37.9293 21.9456 35.6224 21.1863C35.3542 21.098 35.1667 20.8514 35.1667 20.569V19.0473C35.1667 18.6396 35.5468 18.3376 35.9386 18.45C38.8605 19.2879 41.2685 20.9244 43.1625 23.3596C45.2208 26.0061 46.25 29.0529 46.25 32.5C46.25 35.9471 45.2208 38.9939 43.1625 41.6404C41.2685 44.0755 38.8605 45.7121 35.9386 46.55ZM18.3833 37.4264C18.0336 37.4264 17.75 37.1429 17.75 36.7931V28.2883C17.75 27.9386 18.0336 27.655 18.3833 27.655H23.8158C23.9868 27.655 24.1506 27.5858 24.2699 27.4631L30.9126 20.6306C31.3089 20.223 32 20.5036 32 21.0721V44.0093C32 44.5779 31.3089 44.8584 30.9126 44.4508L24.2699 37.6183C24.1506 37.4956 23.9868 37.4264 23.8158 37.4264H18.3833ZM35.4697 38.8998C35.08 39.107 34.639 38.8024 34.639 38.3611V26.6619C34.639 26.2216 35.0781 25.9169 35.468 26.1216C36.4647 26.6451 37.2812 27.4005 37.9177 28.3879C38.7226 29.6364 39.125 31.0207 39.125 32.5407C39.125 34.0336 38.7182 35.402 37.9046 36.6459C37.2635 37.6261 36.4519 38.3774 35.4697 38.8998Z"
        }
      ) })
    ]
  }
);
export {
  s as VideoPlayerSoundOnIcon
};
